import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['element']
  static values = {
    interval: { type: Number, default: 10000 },
    index: { type: Number, default: 0 }
  }

  connect() {
    this.scrollInterval = setInterval(() => {
      this.advanceScroll()
    }, this.intervalValue)
  }

  disconnect() {
    clearInterval(this.scrollInterval)
  }

  advanceScroll() {
    this.isAutoScrolling = true
    
    this.element.scrollBy({
      top: this.element.clientHeight,
      behavior: 'smooth'
    })

    this.indexValue++

    if (this.indexValue >= this.elementTargets.length) {
      this.indexValue = 0

      this.element.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    // This uses a 1s timeout to reset the isAutoScrolling flag because 
    // the scrollEnd event is not reliable across all browsers (mainly Safari)
    setTimeout(() => {
      this.isAutoScrolling = false
    }, 1000)
  }
  
  handleScroll(event) {
    if (this.isAutoScrolling)
      return 
    else {
      clearInterval(this.scrollInterval)
    }
  }
}
